import { render, staticRenderFns } from "./FavouriteCount.vue?vue&type=template&id=f63557ec&"
import script from "./FavouriteCount.vue?vue&type=script&lang=js&"
export * from "./FavouriteCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports